export var SuperHero = {
  fontSize: {
    xs: '52px',
    sm: '66px',
    md: '66px',
    lg: '82px',
    xl: '102px'
  },
  lineHeight: {
    xs: '62px',
    sm: '78px',
    md: '78px',
    lg: '98px',
    xl: '116px'
  }
};